import { useLangContext } from "../../providers/LangProvider/LangProviderContext";
import { DisconnectModalOffcanvasStyled, DisconnectModalStyled } from "./styled/DisconnectModalStyled";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getWebsocketInited } from "../../providers/WebSocketProvider/websocketSelectors";
import {
    useDisconnectedStatus,
} from '../../modules/InternetConnection/hooks/useDisconnectedStatus';
import getConnectionStatusText from '../../modules/InternetConnection/utils/getConnectionStatusText';
import ConnectionStatusIcon from '../../modules/InternetConnection/components/ConnectionStatusIcon';

export const DisconnectModal = () => {
    const { getLangPath } = useLangContext();
    const status = useDisconnectedStatus();
    const [show, setShow] = useState(false);
    const inited = useSelector(getWebsocketInited);
    const error = status === 'disconnected' ? 'offline' : '';
    useEffect(() => {
        if (inited === null) {
            setShow(false);
        } else {
            if (status === 'connected') {
                const timeout = setTimeout(() => {
                    setShow(false);
                }, 1000);
                return () => {
                    clearTimeout(timeout);
                };
            } else {
                setShow(true);
            }
        }
    }, [inited, status]);

    return <>
        <DisconnectModalStyled  show={show ? 'show' : '' }/>
        <DisconnectModalOffcanvasStyled  show={show} backdrop={Boolean(error)} placement="bottom" error={error} >
            <ConnectionStatusIcon status={status} />
            {getLangPath(getConnectionStatusText(status))}
        </DisconnectModalOffcanvasStyled>
    </>
}
